export const INFLUENCER_TERMS_VERSION = 'v1.1'
